import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { Shimmer as ShimmerIcon } from "@/assets/icons/24/Shimmer";
import { useAuth } from "@/auth";
import { cn } from "@/common/utils/css.utils";
import { NewsLetterForm } from "@/components/Footer/NewsLetterForm";
import { Button } from "@/ui/cva/Button";
import { Heading } from "@/ui/cva/Heading";
import NoSSR from "@mpth/react-no-ssr";

export const FooterNewsletter = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { isLoggedIn } = useAuth();

  const handleClick = () => {
    router.push({
      pathname: "/account/signup",
      query: {
        returnUrl: router.asPath,
      },
    });
  };

  return (
    <div className={cn("flex flex-col space-y-4", className)}>
      <Heading as="h5" className="text-brand-500">
        {t("footer:footer-newsletter")}
      </Heading>
      <NewsLetterForm />
      <NoSSR>
        {!isLoggedIn ? (
          <>
            <Heading as="h5" className="text-brand-500">
              {t("footer:footer-get-deals")}
            </Heading>
            <Button
              size="large"
              leftIcon={<ShimmerIcon />}
              onClick={handleClick}
            >
              {t("footer:footer-create-account-btn")}
            </Button>
          </>
        ) : null}
      </NoSSR>
    </div>
  );
};
